import React, { useState } from 'react';

/**
 * Coque portail membre mobile (mm-*).
 * Toujours masquée en desktop (`md:hidden`) — le bureau a sa propre composition.
 */
export function MemberMobileShell({
  children,
  className = '',
  bottomPad = true,
}) {
  return (
    <div
      className={`mm-shell md:hidden space-y-3 ${
        bottomPad ? 'pb-[calc(1rem+env(safe-area-inset-bottom,0px))]' : ''
      } ${className}`}
    >
      {children}
    </div>
  );
}

export function MemberMobileHero({
  label,
  title,
  hint,
  tone = 'neutral',
  actions = null,
  children = null,
}) {
  const toneClass =
    {
      neutral: '',
      ok: 'mm-hero--ok',
      warn: 'mm-hero--warn',
      info: 'mm-hero--info',
    }[tone] || '';

  const labelTone = {
    neutral: 'text-slate-500',
    ok: 'text-emerald-700/85',
    warn: 'text-amber-800/85',
    info: 'text-[#1f6ab8]',
  };

  return (
    <section className={`mm-hero relative ${toneClass}`}>
      <div className="relative z-[1]">
        {label ? (
          <p className={`mm-hero__label ${labelTone[tone] || labelTone.neutral}`}>{label}</p>
        ) : null}
        {title ? (
          <p className="mm-hero__title mt-1 text-[#0f3350]">{title}</p>
        ) : null}
        {hint ? <p className="mt-1.5 text-sm leading-snug text-slate-600/90">{hint}</p> : null}
        {children}
        {actions ? <div className="mt-3.5 flex flex-wrap gap-2">{actions}</div> : null}
      </div>
    </section>
  );
}

export function MemberMobileSection({ title, count = null, children, className = '' }) {
  return (
    <section className={`space-y-2 ${className}`}>
      {title ? (
        <h2 className="px-0.5 font-display text-[11px] font-bold uppercase tracking-[0.12em] text-slate-500">
          {title}
          {count != null ? ` · ${count}` : ''}
        </h2>
      ) : null}
      {children}
    </section>
  );
}

export function MemberMobileList({ children }) {
  return (
    <ul className="mm-card divide-y divide-slate-100/90 overflow-hidden">
      {children}
    </ul>
  );
}

export function MemberMobileCollapse({
  title,
  defaultOpen = false,
  open: openProp,
  onOpenChange,
  children,
  footer = null,
}) {
  const [uncontrolledOpen, setUncontrolledOpen] = useState(defaultOpen);
  const controlled = typeof openProp === 'boolean';
  const open = controlled ? openProp : uncontrolledOpen;
  const setOpen = (next) => {
    const value = typeof next === 'function' ? next(open) : next;
    if (!controlled) setUncontrolledOpen(value);
    onOpenChange?.(value);
  };
  return (
    <section className="mm-card overflow-hidden">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="mm-press flex w-full items-center justify-between gap-2 px-3.5 py-3 text-left active:bg-white/40"
        aria-expanded={open}
      >
        <span className="text-sm font-bold tracking-tight text-[#0f3350]">{title}</span>
        <span
          className={`inline-flex h-7 w-7 items-center justify-center rounded-xl bg-slate-100/80 text-slate-500 transition-transform duration-300 ${
            open ? 'rotate-180' : ''
          }`}
          aria-hidden
        >
          ▾
        </span>
      </button>
      {open ? (
        <div className="border-t border-slate-100/90 px-3.5 pb-3 pt-1 animate-[mm-rise_0.35s_ease]">
          {children}
          {footer}
        </div>
      ) : null}
    </section>
  );
}

export default MemberMobileShell;
